// extracted by mini-css-extract-plugin
export default {"formHeading":"_J-z","form":"aK-z","submitBtn":"bK-z","disabled":"cK-z","input":"dK-z","error":"eK-z","submitMsg":"fK-z","signIn":"gK-z"};